import React, { useMemo } from 'react';
import { Provider as SnackbarProvider } from '@radix-ui/react-toast';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import { TooltipProvider } from 'components/Tooltip/Tooltip';
import { generateTheme } from './theme';
const ThemeProvider = ({
  children,
  baseColors
}) => {
  const theme = useMemo(() => generateTheme(baseColors), [baseColors]);
  return /*#__PURE__*/React.createElement(StyledComponentsThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(SnackbarProvider, {
    swipeDirection: "right"
  }, /*#__PURE__*/React.createElement(TooltipProvider, null, children)));
};
export { ThemeProvider };